import { render, staticRenderFns } from "./myTeam.vue?vue&type=template&id=839ceb70&scoped=true"
import script from "./myTeam.vue?vue&type=script&lang=js"
export * from "./myTeam.vue?vue&type=script&lang=js"
import style0 from "./myTeam.vue?vue&type=style&index=0&id=839ceb70&prod&lang=css"
import style1 from "./myTeam.vue?vue&type=style&index=1&id=839ceb70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839ceb70",
  null
  
)

export default component.exports